export default __webpack_public_path__ + "static/media/flag_es.284fc0d7.svg";